import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { EmailDetail } from "@/components/inbox/EmailDetail";
import { EmailList } from "@/components/inbox/EmailList";
import { useEmails } from "@/hooks/useEmails";

import type { Id } from "@convex/_generated/dataModel";

export const Route = createFileRoute("/_authenticated/inbox")({
  component: InboxRoute,
});

function InboxRoute() {
  const { emails, markAsRead, status, loadMore } = useEmails();
  const [selectedId, setSelectedId] = useState<Id<"emails"> | null>(null);

  const selectedEmail = emails.find((e) => e._id === selectedId) ?? null;

  return (
    <div className="flex h-[calc(100vh-4rem)] overflow-hidden">
      <EmailList
        emails={emails}
        selectedId={selectedId}
        onSelect={setSelectedId}
        status={status}
        onLoadMore={loadMore}
        className={selectedEmail ? "hidden md:flex" : "flex"}
      />
      {selectedEmail ? (
        <EmailDetail
          email={selectedEmail}
          onMarkAsRead={() => markAsRead({ emailId: selectedEmail._id })}
          onBack={() => setSelectedId(null)}
        />
      ) : (
        <div className="hidden flex-1 items-center justify-center text-black/40 dark:text-white/40 md:flex">
          Select an email to read
        </div>
      )}
    </div>
  );
}
